import { useNavigate } from 'react-router-dom';
import { TableCell, TableRow } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import { formatDate } from '../../../helpers/formatDate';
import { MemoDraftSummary } from '../../../types';
import { numberToUSDCurrency } from '../../../helpers/numberToUSDCurrency';

interface DraftsTableProps {
  tableData: MemoDraftSummary[];
  showCaseInfo?: boolean;
}

const DraftsTable = ({ tableData, showCaseInfo = true }: DraftsTableProps) => {
  const navigate = useNavigate();

  const onTableRowClick = (draftId: number, caseId: number) => {
    // Navigate to settlement draft editor with draft ID
    navigate(`/payments/settlement-draft?caseId=${caseId}&draftId=${draftId}`);
  };

  const formattedDraftsList = tableData.map((draft: MemoDraftSummary) => ({
    id: draft.draftId,
    caseId: draft.caseId,
    rowFields: {
      ...(showCaseInfo && { referenceId: draft.caseReferenceId || '-' }),
      ...(showCaseInfo && { caseName: draft.caseName || '-' }),
      clientName: draft.clientName || '-',
      defendant: draft.defendantName || '-',
      settledAmount: numberToUSDCurrency(draft.settledAmount),
      filename: draft.filename || '-',
      updatedAt: formatDate(draft.updatedAt as string),
      createdAt: formatDate(draft.createdAt as string),
    },
  }));

  return (
    <>
      {formattedDraftsList.map((tableItem) => (
        <TableRow
          key={tableItem.id}
          onClick={() => onTableRowClick(tableItem.id, tableItem.caseId)}
          sx={{ cursor: 'pointer' }}
        >
          {Object.entries(tableItem.rowFields).map(([fieldName, value]) => (
            <TableCell key={fieldName}>
              {fieldName === 'filename' ? (
                <Tooltip
                  title={String(value)}
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: (theme) => ({
                        backgroundColor: theme.palette.common.white,
                        color: theme.palette.primary.light,
                        borderRadius: '5px',
                        boxShadow: '3px',
                        fontFamily: 'Inter',
                        fontSize: '13px',
                        fontWeight: 500,
                        padding: '5px',
                        maxWidth: '250px',
                      }),
                    },
                  }}
                >
                  <span>{value}</span>
                </Tooltip>
              ) : (
                value
              )}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default DraftsTable;
